import { ReactGridLayoutProps } from "react-grid-layout";
import { WidgetInstance } from "mobx-store/stores/customScreens/types";
import { RequestStatus } from "mobx-store";

export interface WidgetGridProps extends ReactGridLayoutProps {
  items: WidgetInstance[];
  focusedItem: string | number | null;
  setFocusedItem: (id: string | number | null) => void;
  requestStatus: RequestStatus;
}

export enum ValidationOptionsKeys {
  REQUIRED = 'REQUIRED'
}